module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAABF0lEQVRYhe2Y0RGCMAyGfzzfZQMdwQ3UCXQE3/LqBrpG3nADNxA2cARHwAnwetfjOAKmBdQ+9HsjDb3/mjSQJFVVISRmQakBMG8+EFEKIAOwF57DKJh5O1gQgBuAjfD6IXXIiGj9bzFonVDaWttNsH8pLArtkNUwcz6BIG/CvmV92PwyCb/scfGlAHBgZhFS9YRsKcgnFAN7eTJhdQyZOZ2FsI6ns9Y5hawJMyfC6AgRmSJ5/+QdXFJHQRpRkEYUpBEFaURBGlGQRvNrX9ofpzAEMfMDgFcP9Q1iDmlEQRre/9REdBFGd1ZTCGr3TmfhMYxX11tqyGw5uIqF8Zy6dnCeoBHR0XSbHUMJX56mSeybHYQ10gPwBlpLNK55KouzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_copy.png
// module id = 5zNc
// module chunks = 4